export const CLEAR_DATA = 'ACTION_CLEAR_DATA';

// generic action that different reducers can pick up to clear their fetched data
export const clearAllFetchedData = () => {
  return {
    type: CLEAR_DATA
  };
};
